import { createSupportingModule, DEFAULT_PRODUCT_VALUE, DEFAULT_SORT, SECTION_TYPES } from './shared/configs';

enum SECTION_ENUM {
  CAREERS = 'キャリア',
  EDITOR_COLUMN = '編集長コラム'
}
const { CAREERS, EDITOR_COLUMN, LIFESTYLE, OLYMPICS, WORLD_CUP } = SECTION_TYPES;

const baseQuery = {
  query: {
    and: [
      { terms: { key: 'Product', value: DEFAULT_PRODUCT_VALUE } },
      { terms: { key: 'SectionType', value: [CAREERS, EDITOR_COLUMN, LIFESTYLE, OLYMPICS, WORLD_CUP] } }
    ]
  },
  ...DEFAULT_SORT
};

const CAREERS_QUERY = createSupportingModule([CAREERS]);
const EDITOR_COLUMN_QUERY = createSupportingModule([EDITOR_COLUMN]);

export { SECTION_ENUM, baseQuery as MAIN, CAREERS_QUERY, EDITOR_COLUMN_QUERY };
